import lineLineChart from "assets/images/chart-images/line-chart.png";
import table from "assets/images/chart-images/table.png";
const timeNone = [
    { id: "TDILTP-L01e", name: "line", chartImage: lineLineChart, disabled: false, description: "AVERAGE" },
    { id: "TDILTP-T01e", name: "table", chartImage: table, v2: "Column", disabled: false, description: "AVERAGE" },
    { id: "TDILTP-T02e", name: "table", chartImage: table, v2: "Row", disabled: false, description: "AVERAGE" },
];

export default timeNone;
